const getPagination = pagination => {
    const { currentPage, pageSize, totalRecords } = pagination;
    return {
        current: currentPage,
        pageSize,
        total: totalRecords
    };
};

export default getPagination;